import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { AppNavigationContext } from '../context/AppNavigationContext';

import { ROUTE_PATH } from '../route/utils';

export const AppNavigationProvider = ({ children }) => {
  const location = useLocation();

  const isCurrentRoute = useCallback(
    (route) => {
      return location.pathname === route;
    },
    [location]
  );

  const memoizedAppHeader = useMemo(() => {
    return isCurrentRoute(ROUTE_PATH.TASKS);
  }, [isCurrentRoute]);

  return (
    <AppNavigationContext.Provider
      value={{
        isCurrentRoute,
        showAppHeader: memoizedAppHeader
      }}
    >
      {children}
    </AppNavigationContext.Provider>
  );
};
